module.exports = {
	"en-tal": {
		"statistics": {
			"24h_activity": "24h activity",
			"7days_activity": "7 days activity",
			"actions": "Actions",
			"activity": "Activity",
			"average_per_day": "Average per day",
			"businesskit_opened": "Unique Talentkits opened",
			"total_businesskit_opened": "Opened",
			"businesskit_per_lead": "Talentkits per talent",
			"businesskit_sent": "Talentkits sent",
			"coupon": "Content card",
			"coupons": "Content cards",
			"coupons_opened": "Content cards opened",
			"coupons_sent": "Content cards sent",
			"coupons_viewed": "Content Card views",
			"cta_clicked": "CTA clicked",
			"day": "Day",
			"days": "Days",
			"get_back_to_lead": "Back to talent",
			"get_back_to_statistics": "Back to statistics",
			"hour": "Hour",
			"hours": "Hours",
			"kit_and_activity": "Kit & activity",
			"kits": "Kits",
			"latest_trackings": "Latest activities",
			"lead_detectors_overview": "Talent hunters overview",
			"lead_kit_and_activity": "Talent, kit & activity",
			"lead_statistics": "Talent trackings",
			"leads": "Talents",
			"leads_cold": "Cold",
			"leads_hot": "Hot",
			"leads_per_day": "talents per day",
			"leads_per_lead_detector": "per talent hunter",
			"leads_warm": "Warm",
			"no_data": "There is no data yet. Try another time time range.",
			"no_data_24_hours": "There is no data for the last 24 hours.",
			"no_data_7_days": "There is no data for the last 7 days.",
			"per_bk_opened": "per talentkit open",
			"project_statistics": "Campaign statistics",
			"see_full_report": "See full report",
			"see_full_statistics": "See full statistics",
			"see_full_tracking_history": "See full tracking history",
			"time_range": "Time range",
			"tracking_activity": "Activity",
			"tracking_kit": "Kit",
			"tracking_lead": "Talent",
			"tracking_time": "Time"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/talents/statistics.en-tal.yml
// module id = 2041
// module chunks = 0